export default __webpack_public_path__ + "static/media/p7-1.7331061a.png";